// Neutral access page shown at /pitch — deliberately does NOT list airline codes.
// User must know their airline code and password (both provided out-of-band).
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const AEROPLAY_MARK_LIGHT =
  "https://customer-assets.emergentagent.com/job_24108f3e-b858-4890-993f-f1e1a60b89e6/artifacts/oot4cqoo_Aeroplay%20logo%202026_Black.png";

const PitchAccessRoute = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const normalized = code.trim().toUpperCase();
    if (!/^[A-Z0-9]{2,3}$/.test(normalized)) {
      setError("Enter a valid 2 or 3 character airline code.");
      return;
    }
    navigate(`/pitch/${normalized}`);
  };

  return (
    <div
      className="min-h-screen w-screen flex flex-col items-center justify-center px-6"
      style={{ backgroundColor: "var(--k-canvas)" }}
    >
      <div className="w-full max-w-[420px]">
        <div className="mb-12 flex flex-col items-center">
          <img src={AEROPLAY_MARK_LIGHT} alt="Aeroplay" style={{ height: 40, width: "auto" }} />
        </div>

        <div className="text-center mb-10">
          <div className="k-eyebrow" style={{ color: "rgba(0,0,0,0.5)" }}>Private Pitch Access</div>
          <h1 className="mt-3 text-[36px] font-semibold tracking-tight leading-tight" style={{ color: "#1d1d1f" }}>
            Enter your<br />airline code.
          </h1>
          <p className="mt-3 text-[15px]" style={{ color: "rgba(0,0,0,0.55)" }}>
            Your Aeroplay account manager shared this with you.
          </p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <input
            type="text"
            autoFocus
            value={code}
            maxLength={3}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            data-testid="pitch-code-input"
            placeholder="e.g. CX"
            aria-label="Airline code"
            className="w-full h-14 rounded-xl bg-white border border-black/15 focus:border-[#1d1d1f] focus:ring-4 focus:ring-black/[0.06] outline-none px-4 text-center text-[22px] tracking-[0.4em] uppercase font-semibold transition-all"
            style={{ color: "#1d1d1f" }}
          />
          {error && (
            <div
              className="text-[14px] text-rose-600 flex items-center gap-2"
              role="alert"
              data-testid="pitch-code-error"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-rose-600" /> {error}
            </div>
          )}
          <button
            type="submit"
            data-testid="pitch-code-submit"
            className="w-full h-12 rounded-full font-semibold text-[15px] transition-all hover:scale-[1.005] active:scale-[0.99]"
            style={{ backgroundColor: "#1d1d1f", color: "#ffffff" }}
          >
            Continue
          </button>
        </form>

        <p className="text-center text-[13px] mt-10" style={{ color: "rgba(0,0,0,0.45)" }}>
          <a href="/" className="underline underline-offset-2 hover:text-[#1d1d1f]">Go to the public pitch</a>
        </p>
      </div>
    </div>
  );
};

export default PitchAccessRoute;
